import React from 'react';
import {
    BackButton,
    CloseButton,
    ToolbarTitle,
    ToolbarWrapper,
} from './styled';
import { detectMobile } from '../../utils/UiHelper';

const HIGHER_HEADER = ['Kontohistorik', 'Udbetaling', 'Kontooplysninger'];

const ViewPageToolbarNew = ({ onBackBtn, onCloseBtn, title }) => {
    const isMobile = detectMobile();
    const handleBackClick = () => {
        if (typeof onBackBtn === 'function') {
            onBackBtn();
        }
    };

    const handleCloseClick = () => {
        if (typeof onCloseBtn === 'function') {
            onCloseBtn();
        }
    };

    return (
        <ToolbarWrapper
            $higher={HIGHER_HEADER.includes(title)}
            $isMobile={isMobile}
        >
            {onBackBtn && (
                <BackButton onClick={onBackBtn}>
                    <i className="fa fa-angle-left fa-2x" aria-hidden="true" />
                </BackButton>
            )}

            <ToolbarTitle
                $fontSize={'16px'}
                $fontWeight={'bold'}
                $lh={'24px'}
                $withBackBtn={!!onBackBtn}
                onClick={onBackBtn}
            >
                {title}
            </ToolbarTitle>

            {onCloseBtn && (
                <CloseButton onClick={onCloseBtn}>
                    <i className="fa fa-times" aria-hidden="true" />
                </CloseButton>
            )}
        </ToolbarWrapper>
    );
};

export default ViewPageToolbarNew;
